import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import { Paper } from '@material-ui/core';
import ProfileMain from './ProfileMain';
import ProfilePassword from './ProfilePassword';
import ProfileGroups from './ProfileGroups';
import ProfileDivisions from './ProfileDivisions';
import ProfileTransport from './ProfileTransport';
import { USER_GROUPS } from '../../../../common/constants/userGroups';

const mapStateToProps = (state) => {
    const { loading } = state.UserManagement.User_profile.User_profile_table;
    const { groups } = state.App.App_content.user;

    return { loading, groups };
};

const { TabPane } = Tabs;

class ProfileTabs extends Component {
    state = {
        activeTab: '1',
    };

    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_USER_PROFILE' });
    }

    toggle = (tab) => this.state.activeTab !== tab && this.setState({ activeTab: tab });

    render() {
        const { activeTab } = this.state;
        const { id, groups, loading } = this.props;
        const isAdmin = groups.some((group) => group._id === USER_GROUPS.ADMIN);
        const isTransportManagement = groups.some((group) => group._id === USER_GROUPS.TRANSPORT_MANAGEMENT);

        return (
            <Paper style={{ padding: 24 }}>
                <Tabs defaultActiveKey={activeTab} onChange={this.toggle}>
                    <TabPane tab="Profile" key="1"><ProfileMain id={id} /></TabPane>
                    <TabPane tab="Password" key="2"><ProfilePassword id={id} /></TabPane>
                    {isAdmin && <TabPane tab="Groups" key="3"><ProfileGroups id={id} /></TabPane>}
                    {isAdmin && <TabPane tab="Divisions" key="4"><ProfileDivisions id={id} /></TabPane>}
                    {isTransportManagement
                        && <TabPane tab="Transport" disabled={loading} key="5"><ProfileTransport id={id} /></TabPane>
                    }
                </Tabs>
            </Paper>
        );
    }
}

ProfileTabs.propTypes = {
    groups: PropTypes.arrayOf(PropTypes.string),
    loading: PropTypes.bool,
    id: PropTypes.string
};

ProfileTabs.defaultProps = {
    groups: [],
};

export default connect(mapStateToProps, null)(ProfileTabs);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/components/ProfileTabs.js